import { DiagnosisDto } from '@therapist/shared/models/diagnosis/diagnosis.dto';
import { ExerciseBaseModel } from '@therapist/shared/models/exercise/exercise-base.model';

export interface ExerciseTemplateDto extends ExerciseBaseModel {
  id: string;
  description: string;

  variants: ExerciseTemplateDto[];
}

export enum ExerciseActivityTypeEnum {
  Active = 'Active',
  Assistive = 'Assistive',
  Passive = 'Passive'
}
